const TAG_CONSTANTS = {
    DEFAULT_FEED_TAG: {
        title: 'All',
        slug: 'all'
    }
}

export default TAG_CONSTANTS
